import {cs}                from "@Common/react/chain-services";
import {Static2}           from "@Common/react/static-2";

export const PickupAddressLogic = ({next: rootNext}) => cs(

    ["domRef", (_, next) => Static2({next})],

    ["step1", ({}, next) => rootNext({
        next,
    })],

    ({step1, domRef}) => step1.next({
        ui: {
            domRef,
        },
    }),
);